import HttpRequest from "@/services/http_request";

class UserProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  async login(payload) {
    const { data } = await this.create("authen/apilogin", payload);
    return data;
  }

  async keepalive(payload) {
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(payload)}`
    });
    const res = await this.create("authen/keepalive");
    return res;
  }

  async currentUser(payload) {
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(payload.token)}`,
      userid: this.variableParser(payload.request.userid),
      lang: this.variableParser(payload.request.lang)
    });
    const res = await this.get("reg/enroll/currentuser");
    const { data } = res.data;
    // const data = [
    //   {
    //     USERCODE_TXT: "623 1205 190",
    //     USERNAME: "นาย ธนกร สุคันธตุล",
    //     LEVELNAME: "ปริญญาตรี",
    //     STUDENTYEAR: 1,
    //     FACULTYNAME: "การจัดการ",
    //     DEPARTMENTNAME: "การจัดการการท่องเที่ยว",
    //     PROGRAMNAME: "บริหารธุรกิจบัณฑิต สาขาวิชาการจัดการการท่องเที่ยว",
    //     ADVISORNAME: "Arjan Panupong Patarachao",
    //     USERSTATUS_DES: "10:ปัจจุบัน (ปกติ)",
    //     USERID: 6231205214,
    //     USERCODE: "6231205190",
    //     LEVELID: 3,
    //     FACULTYID: 12,
    //     DEPARTMENTID: 1205,
    //     PROGRAMID: 623120500,
    //     MINORPROGRAMID: 0,
    //     GPA: 0,
    //     ADMITACADYEAR: 2562,
    //     ADMITSEMESTER: 1,
    //     STUDYPLANID: 623120500,
    //     STUDYPLANACADYEAR: 25562,
    //     STUDYPLANSEMESTER: 1,
    //     USERSTATUS: 10,
    //     CURRENT_ACADYEAR: 2562,
    //     CURRENT_SEMESTER: 1,
    //     ENROLL_ACADYEAR: 2562,
    //     ENROLL_SEMESTER: 1,
    //     ENROLL_ACAD_SEMESTER_TEXT: "ภาคการศึกษาต้น ปีการศึกษา 2562",
    //     SCHEDULE_PERIOD: 2,
    //     SCHEDULEGROUPID: 1000,
    //     USER_TYPE: "S",
    //     ISSHOW_ADVISORWARNING: "N",
    //     ISSHOW_ENROLLCONFIRMBUTTON: "Y",
    //     ISSHOW_ADDENROLLBUTTON: "N"
    //   }
    // ];
    return data;
  }

  async currentCalendar(payload) {
    const { token, request } = payload;
    const headers = {
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.currentsemester),
      schedulegroupid: this.variableParser(request.schedulegroupid),
      usertype: this.variableParser(request.usertype),
      lang: this.variableParser(request.lang)
    };
    if (request.studentid != undefined) {
      headers["studentid"] = this.variableParser(request.studentid);
    }
    this.setHeader(headers);
    const res = await this.get("reg/enroll/currentcalendar");
    const { data } = res.data;
    return data;
  }
}

export default UserProvider;
